import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ComponentRef, EventEmitter, input, Input, OnChanges, OnInit, Output, SimpleChanges, Type } from "@angular/core";
import { FormGroup, Validators } from "@angular/forms";
import { debounceTime, distinctUntilChanged, Subscription } from "rxjs";
import { Variable } from "src/app/forms/formula-tester/formula-tester.component";
import { FormulaTSService } from "src/app/services/formula-ts.service";
import { FormulaServices } from "src/app/services/formula.service";
import { WebhookConfiguration, WebhookField, WorkFlowAction, WorkFlowActionInputParameter } from "../webhook-interfaces/configuration";
import { ModalOptions, NzModalService } from "ng-zorro-antd/modal";
import { REGISTRY } from "src/app/interfaces/registry-services";
import { DynamicLoaderService } from "src/app/services/dynamic-loader.service";
import { WebHookCommonServices } from "../webhook-services/webhook-commom.services";
import { LanguageServices } from "src/app/services/LanguageServices";

@Component({
    selector:'webhook-common',
    standalone: false,
    templateUrl:'./common.components.html',
})

export class WebhookCommonComponent implements OnInit, OnChanges {
   
    @Input() field:WebhookField;
    @Input() configuration:WebhookConfiguration;
    @Input() mainformGroup:FormGroup;
    @Input() rootForm:FormGroup
    //@Input() formValidationList: {id:string, form:FormGroup<any>}[] =[];
    @Input() variables:Variable[] = [];
    @Input() key:string;
    @Input()   n:number=0;
    @Input() fieldNew:string;
    @Output() change:EventEmitter<any> = new EventEmitter<any>();
    filteredOptionsAutocomplete: string[] = [];
    sub1: Subscription;
    sub2: Subscription;
    map: Map<string, any>;
    hide:Boolean = false;
    onChangeValue: any;
    onChangeField: any;
    onOk: any;
    onCancel: any;
       

    isFormGroup(formGroup:FormGroup, key:string): boolean {
        if ( key!=null && formGroup!=null){
            if ( formGroup.get(key) instanceof FormGroup ){
                if ( (this.field.type == "keyValueObject" || this.field.type == "section") && this.n+1==this.field.field.split(".").length){
                    return false;
                }else{
                    return true;
                }
            }   
        }
        

        return false;   

    }

    GetFormGroup(formGroup:FormGroup, key:string): FormGroup {
        return formGroup.get(key) as FormGroup;
    }

    // Getter para verificar se o control existe no formGroup
    get controlExists(): boolean {
        return !!(this.mainformGroup && this.fieldNew && this.mainformGroup.get(this.fieldNew));
    }

    ngOnDestroy(): void {
        if ( this.sub1!= null ){
            this.sub1.unsubscribe();
        }
        if ( this.sub2!= null ){
            this.sub2.unsubscribe();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        // ⭐ Detecta mudanças no @Input() field e notifica componentes filhos
        if (changes['field'] && !changes['field'].firstChange) {
            // Força detecção de mudança nos componentes filhos
            this.cd.markForCheck();
        }
    }

    ngOnInit(): void {
        this.fieldNew = this.field.field.split('.')[this.n];
        this.map = new Map<string,any>();
        this.loadListener();
        this.initValues();
    }

    get fieldLength(){
        return this.field.field.split(".").length;
    }

    initValues() {
        if ( this.field.onInit != null ){
                
             if ( this.field.onInit!=null && this.rootForm!=null && (this.n+1)==this.fieldLength){
                this.tsFormula.execute(this.field.onInit,this.map, this.rootForm, this);
            }
        }
    }

    findField(keyName:string): WebhookField {
        
        let fields = this.configuration.fields;
        return this.commomServices.extractTaggedFieldPaths(fields, []).find(p=>p.path.endsWith(keyName)).field;
    }

    


    constructor(
        protected modalService:NzModalService,
        protected formulaServices:FormulaServices,  
        protected tsFormula:FormulaTSService,
        protected cd:ChangeDetectorRef,
        protected dynamicLoader: DynamicLoaderService,
        protected commomServices: WebHookCommonServices,
        protected translate: LanguageServices,
    )  {
           
    }
   
    loadListener(){
        if ( this.field.type == "select" || this.field.type=="querySelect" || this.field.type=="search"){
            if ( this.rootForm != null &&  this.rootForm.get(this.field.field)!= null && (this.n+1)==this.fieldLength ){
                this.sub1 = this.rootForm.get(this.field.field).valueChanges.subscribe(ob=>{
                    this.executeListener(ob);
                });
            }
        }else{
            if ( this.field.type !='divider' &&  this.field.type !='button'){
                if ( this.rootForm != null && this.rootForm.get(this.field.field)!= null && (this.n+1)==this.fieldLength){
                    this.sub1 = this.rootForm.get(this.field.field).valueChanges.pipe(
                    debounceTime(500), 
                    distinctUntilChanged(), 
                    ).subscribe(ob=>{
                        this.executeListener(ob);
                    });
                }
            }
        }

        if ( this.field.autocomplete!= null ){
            if ( this.rootForm != null &&  this.rootForm.get(this.field.field)!= null && (this.n+1)==this.fieldLength){
                this.sub2 = this.rootForm.get(this.field.field)?.valueChanges.subscribe(value => {
                    this.filteredOptionsAutocomplete = this.field.autocomplete.filter(opt =>{
                            if ( value == null){
                                return [];
                            }
                            return opt.toLowerCase().includes(value.toLowerCase())
                        }
                    );
                });
            }
        }
    }

    onChangeEvent(onChangeValue,field:WebhookField){

        if ( field.onChange!= null ){
            this.onChangeValue = onChangeValue;
            this.onChangeField = field
            this.tsFormula.execute(field.onChange.toString(),this.map, this.rootForm,this);
        }
    }

    onOkFunction(onOk,field:WorkFlowAction){
        if ( field.onOk!= null ){
            this.onOk = onOk;
            this.tsFormula.execute(field.onOk.function.toString(),this.map, this.rootForm,this);
        }
    }

    onCancelFunction(onCancel,field:WorkFlowAction){
        if ( field.onCancel!= null ){
            this.onCancel = onCancel;
            this.tsFormula.execute(field.onCancel.function.toString(),this.map, this.rootForm,this);
        }
    }

    executeListener(ob: any) {
        
        if ( this.variables != null ){
            let indexVariable = this.variables.findIndex(s=>s.key=="@"+this.fieldNew.toUpperCase()+"_VALUE");
            if ( indexVariable >-1){
                this.variables[indexVariable].value = ob;
            }else{
                this.variables.push({
                    key:"@"+this.fieldNew.toUpperCase()+"_VALUE",
                    value: ob,
                    type:"S"
                });
            }
        }

        if ( this.field.formula!=null){
            
            this.tsFormula.toMap(this.variables,this.map);
            this.tsFormula.toMap(this.rootForm,this.map);
            this.tsFormula.execute(this.field.formula,this.map, this.rootForm,this);
        }
    
        this.change.emit(ob);
    }

    openFormula(){
        if ( this.rootForm.get(this.field.field)!= null && (this.n+1)==this.fieldLength){
            this.formulaServices.openFormula(this.rootForm.get(this.field.field).value,this.variables).then(formula=>{
                this.rootForm.get(this.field.field).setValue(formula);
            });
        }
    }

    setRequired(fieldName:string, required:boolean){
        let control = this.findForm(fieldName);

        if ( control != null ){
            if ( required ){
                control.addValidators(Validators.required);
                control.updateValueAndValidity();
            }else{
                control.removeValidators(Validators.required);
                control.updateValueAndValidity();
            }
        }
    }

    
    findForm(fieldName:string){
        return this.rootForm.get(fieldName);
    }

    createTitle(action: WorkFlowAction){
        let interpoledTitle = {};
        
        if ( action.titleParams != null){
            for ( const param of action.titleParams ){
                if ( param.type == "STRING"){
                    interpoledTitle[param.key] =  new String(param.value);
                }
                if ( param.type == "NUMBER"){
                    interpoledTitle[param.key] = new Number(param.value);
                }   
                if ( param.type == "BOOLEAN"){   
                    interpoledTitle[param.key] = param.value.trim().toLowerCase() === 'true';
                }   
                if ( param.type == "FORMULA"){  
                    interpoledTitle[param.key] = String(this.tsFormula.execute(param.value, this.map, this.rootForm, this));
                }
            }
        }
        return this.translate.instant(action.title,interpoledTitle);
    }
    
    openComponentAction(event: MouseEvent, action: WorkFlowAction): void {
        event.stopPropagation();
        if (action) {
            let component:Type<any> = REGISTRY.get(action.component);

            let title = this.createTitle(action);

            let modalConfiguration:ModalOptions = {
                nzTitle: title || 'Action',
                nzContent: component,
                nzWidth: action.width || '80%',
                nzClassName: action.className || 'modal-size-80',
                nzStyle: action.style!== null ? { 'top': '5px'}: JSON.parse(action.style),
                nzData: {
                    field: this.field,
                    configuration: this.configuration,
                    mainformGroup: this.mainformGroup,
                    rootForm: this.rootForm,
                    variables: this.variables,
                    key: this.key,
                    n: this.n,
                    action:action.data
                },  
                nzMask:false,
                nzOkText: action.okText || 'OK',
                nzCancelText: action.cancelText || 'Cancel',
                nzOnOk: (val)=>{
                    
                    if ( action.onOk!= null ){
                        if ( action.onOk.eventName != null ){
                            return this.onOkFunction(val, action);
                        }else{
                            return action.onOk.function(val);
                        }
                    }else{
                        return Promise.resolve();
                    }
                },
                nzOnCancel: (val)=>{
                    if ( action.onCancel!= null ){
                        if ( action.onCancel.eventName != null ){
                            return this.onOkFunction(val, action);
                        }else{
                            return action.onCancel.function(val);
                        }
                    }else{
                        return Promise.resolve();
                    }
                }
            }

            if ( action.noFooter ){
                modalConfiguration.nzFooter = null;
            }

            let modalRef = this.modalService.create(modalConfiguration);

            this.dynamicLoader.loadParameter(modalRef.getContentComponent(),this.prepareInputData(action.data) || {});
        }
    }

    prepareInputData(data:WorkFlowActionInputParameter[] | {}): any {
        let dataObject: any = {};
        if (data) {
            
            if ( data instanceof Array ) {
            
                for (const item of data) {
                    console.log("Item", item);
                    if ( item.type == "STRING"){
                        dataObject[item.key] =  new String(item.value);
                    }
                    if ( item.type == "NUMBER"){
                        dataObject[item.key] = new Number(item.value);
                    }
                    if ( item.type == "BOOLEAN"){   
                        dataObject[item.key] = item.value.trim().toLowerCase() === 'true';
                    }
                    if ( item.type == "FORMULA"){
                        let val = this.tsFormula.execute(item.value, this.map, this.rootForm, this);
                        if ( val instanceof Object || val instanceof Array){
                            dataObject[item.key] = JSON.parse(JSON.stringify(val));
                        }else{
                            dataObject[item.key] = String(val);
                        }
                    }

                }
            } else if (data instanceof Object) {
                return data;
            }
            
            return dataObject;
        }
        return {};
    }

    
}